var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fullscreen-menu"},[_c('div',{staticClass:"menu-container"},_vm._l((_vm.menuImages),function(image,index){return _c('img',{key:index,staticClass:"menu-image",attrs:{"src":image,"alt":`Menu Page ${index + 1}`}})}),0),_c('button',{staticClass:"back-button",on:{"click":_vm.closeFullScreen}},[_vm._v("返回")])])
}
var staticRenderFns = []

export { render, staticRenderFns }